module.exports = __webpack_public_path__ + "static/business-woman-desktop.21a6681e.webp";